import React, { useRef } from 'react';

const InputToken = ({
  ...rest
}) => {
  const input1Ref = useRef(null);
  const input2Ref = useRef(null);
  const input3Ref = useRef(null);
  const input4Ref = useRef(null);
  const input5Ref = useRef(null);
  const input6Ref = useRef(null);  

  const handleInput = (e, nextInputRef) => {
    if (e.target.value.length === e.target.maxLength) {
      nextInputRef.current.focus();
    }
  };


  return (
    <div className="input-container input-token">
        <input
          type="text"
          id="confirmarSenha1"
          name="confirmarSenha1"
          maxLength="1"
          autoComplete="off"
          className="input-dado"
          ref={input1Ref}
          onInput={(e) => handleInput(e, input2Ref)}
          {...rest}
        />
        <input
          type="text"
          id="confirmarSenha2"
          name="confirmarSenha2"
          maxLength="1"
          autoComplete="off"
          className="input-dado"
          ref={input2Ref}
          onInput={(e) => handleInput(e, input3Ref)}
          {...rest}
        />
        <input
          type="text"
          id="confirmarSenha3"
          name="confirmarSenha3"
          maxLength="1"
          autoComplete="off"
          className="input-dado"
          ref={input3Ref}
          onInput={(e) => handleInput(e, input4Ref)}
          {...rest}
        />
        <input
          type="text"
          id="confirmarSenha4"
          name="confirmarSenha4"
          maxLength="1"
          autoComplete="off"
          className="input-dado"
          ref={input4Ref}
          onInput={(e) => handleInput(e, input5Ref)}
          {...rest}
        />        
        <input
          type="text"
          id="confirmarSenha5"
          name="confirmarSenha5"
          maxLength="1"
          autoComplete="off"
          className="input-dado"
          ref={input5Ref}
          onInput={(e) => handleInput(e, input6Ref)}
          {...rest}
        />
        <input
          type="text"
          id="confirmarSenha6"
          name="confirmarSenha6"
          maxLength="1"
          autoComplete="off"
          className="input-dado"
          ref={input6Ref}
          {...rest}
        />        
      </div>
  );
};

export default InputToken;
